<template>
	<div class="banner"></div>
</template>

<script>
	export default {
		
	}
</script>

<style scoped>
	.banner{ position: relative;height: 400px;background-image: url(../../../../assets/case_banner.png);background-repeat: no-repeat;background-position: center center; }
</style>
